module.exports = __webpack_public_path__ + "img/greenlife0.4b7da2a5.svg";